import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import LoaderComponent from "../../Common/LoaderComponent";
import useRequiredFields from "../../../hooks/useRequiredFields";
import IsLogin from "../../Common/IsLogin";
import Http from "../../Common/Http";
import Select from "react-select";
const Create = () => {
  const navigate = useNavigate();
  const [inputs, setInputs] = useState({}); // ✅ Fix: Initialize inputs properly
  const [error, setError] = useState({});
  const { checkRequiredFields } = useRequiredFields();
  const [role, setRole] = useState([]);

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };
  useEffect(() => {
    const fetchShapeTypes = async () => {
      try {
        const res = await Http.get("/staff-type-check");
        setRole(res.data);
        if (res.data === "sample") {
          setInputs((values) => ({
            ...values,
            status: "on_test", // fallback to empty if option is undefined
          }));
        } else {
          setInputs({
            status: "active",
          });
        }
      } catch (error) {
        console.error("Error fetching shape types:", error);
      }
    };

    fetchShapeTypes();
  }, []);

  console.log(inputs);

  const formSubmit = async (e) => {
    e.preventDefault();

    const { isValid, error } = checkRequiredFields(inputs);
    if (!isValid) {
      setError(error);
    }

    try {
      await Http.post("/gless-colour-create", inputs).then((res) => {
        console.log(res);
      });
      // Swal.fire("Success!", "Gless Colour created successfully.", "success");
      navigate("/gless-colour");
    } catch (err) {
      Swal.fire("Error!", "Something went wrong.", "error");
    }
  };
  let statusOptions = [];
  if (role === "sample") {
    statusOptions = [
      { value: "active", label: "Active" },
      { value: "inactive", label: "Inactive" },
      { value: "on_test", label: "On Test" },
    ];
  } else {
    statusOptions = [
      { value: "active", label: "Active" },
      { value: "inactive", label: "Inactive" },
    ];
  }
  const handleStatusChange = (option) => {
    console.log(option.value, "option");
    setInputs((values) => ({
      ...values,
      status: option?.value || "", // fallback to empty if option is undefined
    }));
  };
  return (
    <>
      <IsLogin />
      <div className="am-mainpanel">
        <div className="am-pagetitle g-2">
          <h5 className="am-title">Glaze Colour</h5>
          <Link to="/gless-colour" className="btn btn-primary">
            <i className="fa fa-bars mg-r-6"></i> List
          </Link>
        </div>
        <div className="am-pagebody">
          <div className="card pd-20 pd-sm-40">
            <div className="table-wrapper">
              <form onSubmit={formSubmit}>
                <div className="d-flex flex-row gap-1">
                  <div className="form-group col-lg-6">
                    <label htmlFor="colour_name">Colour Name</label>
                    <input
                      type="text"
                      className="form-control"
                      name="colour_name"
                      onChange={handleChange}
                      data-required="true"
                    />
                  </div>
                  {role !== "sample" && (
                    <div className="form-group col-lg-6">
                      <label htmlFor="colour_name">
                        Status <i className="fa fa-star required"></i>
                      </label>
                      <Select
                        className="basic-single"
                        classNamePrefix="select"
                        name="status"
                        options={statusOptions} // Options for active/inactive
                        // value={inputs.status}
                        onChange={handleStatusChange} // Handle status dropdown change
                      />
                    </div>
                  )}
                </div>
                <div className="form-group col-lg-6">
                  <button type="submit" className="btn btn-primary">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Create;
